import { render } from "./PartnerOffers.vue?vue&type=template&id=2299243e"
import script from "./PartnerOffers.vue?vue&type=script&lang=js"
export * from "./PartnerOffers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__